import React from 'react';
import PropTypes from 'prop-types';
import cx from '../../utils/cx';

const ImageSvg = (props) => {
  const {
    full,
    iconClass,
    svg,
  } = props;

  return (
    <svg className={cx(['icon', ['icon--full', full], [iconClass, iconClass]])}>
      <use xlinkHref={`#${svg}`} />
    </svg>
  );
};

ImageSvg.propTypes = {
  svg: PropTypes.string,
  full: PropTypes.bool,
  iconClass: PropTypes.string,
};

ImageSvg.defaultProps = {
  svg: '',
  full: false,
  iconClass: null,
};

export default ImageSvg;
